import MapContactFieldsUtil from './MapContactFieldsUtil';

export default (templateData = {}) => {
	const {
		TemplateId = '',
		IsTemp = false,
		TemplateName = '',
		OverwriteDuplicate = false,
		Fields = { ...MapContactFieldsUtil.buildDefaultMapping() },
	} = templateData;

	return {
		TemplateId,
		IsTemp,
		TemplateName,
		OverwriteDuplicate,
		Fields,
	};
};
